///<reference path="../../App/plugins/DefinitelyTyped/google.maps.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { MySharedService } from '../App/shared.service';
declare function AddMapScript(): void;
@Component({
    templateUrl: './AppViews/AttendanceMarking/attendanceMarking.html'
})

export class AttendanceMarkingComponent implements OnInit {


    public geoError: string = "";
    public timer: any;

    constant: Constants;
    attendanceItems: any = [];
    public attendanceModel: any = {};
    public geoLocationModel: any = {};
    statusItems: any = [];
    teamItems: any[];
    siteUserItems: any = [];
    drpstatusItems: any = [];
    drpAllstatusItems: any = [];
    userDetail: any;
    selfuser: boolean = true;
    DisplayUser: string = "";
    filter: any = {};
    public utcTime: any;
    public todaysDate: any;
    defaultDate: any;
    public showLoader = false
    utcDate: any;
    ErrorStatus:boolean=false;
    ErrorInTime:boolean=false;


    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        AddMapScript();
        this.attendanceModel = { 'StatusId': '' };
        this.attendanceModel.AttendanceId = 0;
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.constant = new Constants();
        if (this.userDetail.RoleId == 3) {
            this.filter = { 'TeamId': '', 'UserId': this.userDetail.SiteUserId, 'MonthYear': moment().format('MM/YYYY'), 'StatusId': '' };
        }
        else {
            this.filter = { 'TeamId': '', 'UserId': '', 'MonthYear': moment().format('MM/YYYY'), 'StatusId': this.constant.enumAttendanceStatus["NotApproved"] };
        }

        this.DisplayUser = this.userDetail.Name;
    }

    ngOnInit() {
        this.BindFilters();
    }

    public IsPresentChange() {
        debugger
        this.attendanceModel.IsPresent = !this.attendanceModel.IsPresent;
        if (this.attendanceModel.IsPresent == false) {
            this.drpstatusItems = JSON.parse(JSON.stringify(this.drpAllstatusItems.filter(item => item.Value == "7" || item.Value == "5"|| item.Value == "4"|| item.Value == "10" || item.Value == "11")));
        }
        else {
            this.drpstatusItems = JSON.parse(JSON.stringify(this.drpAllstatusItems.filter(item => item.Value == "3" || item.Value == "5" || item.Value == "6" || item.Value == "7")));
        }
    }


    public EditAttendance(dt: any) {
        this.ErrorStatus=false;
        this.ErrorInTime=false;
        if (dt.IsPresent == false) {
            this.drpstatusItems = JSON.parse(JSON.stringify(this.drpAllstatusItems.filter(item => item.Value == "7" || item.Value == "5"|| item.Value == "4"|| item.Value == "10" || item.Value == "11")));
        }
        else {
            this.drpstatusItems = JSON.parse(JSON.stringify(this.drpAllstatusItems.filter(item => item.Value == "3" || item.Value == "5" || item.Value == "6" || item.Value == "7")));
        }
        this.attendanceModel = JSON.parse(JSON.stringify(dt));

        if (dt.StatusId == "3" || dt.StatusId == "5" || dt.StatusId == "6" || dt.StatusId == "7") {
            this.attendanceModel.StatusId = dt.StatusId;
        }
        else {
            this.attendanceModel.StatusId = '';
        }
        // when status is 'Not Approved' then make InTime Transaction date and Time will shift start time.
        if (dt.StatusId == "2") {
            if (dt.ShiftStartTime != null) {
                this.attendanceModel.InDateTime = dt.Date + ' ' + dt.ShiftStartTime;
            }else{
                this.attendanceModel.InDateTime = dt.Date + ' ' + moment().format("HH:mm");
            }
        }

    }

    public MarkPresentIN(dt: any) {
        this.attendanceModel = JSON.parse(JSON.stringify(dt));
        this.attendanceModel.InDateTime = null;
        this.attendanceModel.OutDateTime = null;

        if (this.attendanceModel.AttendanceId == 0) { // On In Button click need to decide the status to be updated.
            if (this.attendanceModel.Date == this.utcDate) {   // if mark attendance on today's date...
                if (dt.IsTodayHoliday == true) {
                    this.attendanceModel.StatusId = this.constant.enumAttendanceStatus["NotApproved"]; // if today is holiday then status should be Not Approved
                }
                else {
                    this.attendanceModel.StatusId = this.constant.enumAttendanceStatus["Present"];  // if today is not holiday then direct status will be Present
                }
            }
            else {
                this.attendanceModel.StatusId = this.constant.enumAttendanceStatus["NotApproved"];  // if mark attendance is applied for day other than Today then status should be passed as NotApproved
            }
        }
        this.attendanceModel.IsPresent = true;
        this.attendanceModel.MarkedBy = this.userDetail.SiteUserId;
        this.attendanceModel.ApprovedBy = null;
        this.SaveAttendance();
    }

    public MarkPresentOUT(dt: any) {
        this.attendanceModel = JSON.parse(JSON.stringify(dt));
        this.attendanceModel.OutDateTime = null;
        this.attendanceModel.MarkedBy = this.userDetail.SiteUserId;
        this.attendanceModel.ApprovedBy = null;
        this.SaveAttendance();
    }

    public AddAttendance() {
        this.attendanceModel.ApprovedBy = this.userDetail.SiteUserId;
        this.SaveAttendance();
    }

    public SaveAttendance() {
        var flag = true;
        this.ErrorStatus=false;
        this.ErrorInTime=false;

        if (this.attendanceModel.StatusId.length == 0)
        { flag = false; this.ErrorStatus=true; }

        if (this.attendanceModel.ApprovedBy != null && this.attendanceModel.StatusId != 7 && this.attendanceModel.StatusId != 5 && this.attendanceModel.StatusId != 11) {
            if (this.attendanceModel.InDateTime == null || this.attendanceModel.InDateTime.substr(this.attendanceModel.InDateTime.length - 5) === "00:00") {
                flag = false;
               this.ErrorInTime=true;
            }
        }

        if (this.attendanceModel.MarkedBy != null) {
            if (this.attendanceModel.AttendanceId != 0) {
                this.attendanceModel.OutIP = this.geoLocationModel.IP;
                this.attendanceModel.OutLatitude = this.geoLocationModel.Latitude;
                this.attendanceModel.OutLongitude = this.geoLocationModel.Longitude;
                this.attendanceModel.OutAddress = this.geoLocationModel.Address;
            }
            else {
                this.attendanceModel.InIP = this.geoLocationModel.IP;
                this.attendanceModel.InLatitude = this.geoLocationModel.Latitude;
                this.attendanceModel.InLongitude = this.geoLocationModel.Longitude;
                this.attendanceModel.InAddress = this.geoLocationModel.Address;
            }
        }

        if (flag) {
            this.showLoader = true;
            console.log(this.attendanceModel);
            this._httpService.ajaxPost("Attendance/AddUpdateAttendance", this.attendanceModel).subscribe(
                data => {
                    this._sharedService.ShowMessage(data["Status"].Message);
                },
                err => {
                    console.log("GetAttendance Failed");
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constant.globalError);
                },
                () => {
                    $('#addAttendance').modal('hide');
                    this.attendanceModel = { 'StatusId': '' };
                    this.GetAttendance();
                    this.showLoader = false;
                });
        }
        else {
            return;
        }
    }





    public clearFilter() {
        if (this.userDetail.RoleId == 3) {
            this.filter = { 'TeamId': '', 'UserId': this.userDetail.SiteUserId, 'MonthYear': moment().format('MM/YYYY'), 'StatusId': '' };
        }
        else {
            this.filter = { 'TeamId': '', 'UserId': '', 'MonthYear': moment().format('MM/YYYY'), 'StatusId': this.constant.enumAttendanceStatus["NotApproved"] };
        }
    }


    public GetAttendance() {
        var UserId = 0;UserId =  this.filter.UserId == "" ? 0 : this.filter.UserId;
        var TeamId = this.filter.TeamId == "" ? this.userDetail.TeamID :this.filter.TeamId;

        this.showLoader = true;
        this._httpService.ajaxPost("Attendance/GetAttendance", { "AttendanceId": 0, "UserId": UserId, "TeamId": TeamId, "MonthYear": this.filter.MonthYear, "Date": null, "StatusId": this.filter.StatusId, "LoggedUserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.attendanceItems = data["Attendance"];
                this.utcDate = moment(data["UTCTime"]).format('DD/MM/YYYY');
            },
            err => {
                console.log("GetAttendance Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                if (this.userDetail.SiteUserId == this.filter.UserId) {
                    this.selfuser = true;
                    this.DisplayUser = this.userDetail.Name;
                }
                else {
                    this.selfuser = false;
                    this.DisplayUser = (this.attendanceItems.length > 0 ? this.attendanceItems[0].Name : '');
                }
                this.showLoader = false;
            }
        );
    }

    ngAfterViewInit() {
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY',
            maxDate:moment().set({hour:0,minute:0,second:0,millisecond:0})
        });
        $(".time").datetimepicker({
            format: 'DD/MM/YYYY HH:mm',
            maxDate:moment().add(2,'days').set({hour:0,minute:0,second:0,millisecond:0})
        });
        $("#show-filter").click(function () {
            $(".filter-form").slideToggle();
        }).bind(this);
    }

    public BindFilters() {
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": userId }).subscribe(
            data => {
                this.teamItems = data["AssignedTeam"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this._httpService.ajaxPost('Users/GetUsers', {
                    "IsActive": 1,
                    "Team": this.userDetail.TeamID,
                    "UserId": userId
                }).subscribe(
                    data => {
                        this.siteUserItems = data["Users"];
                        console.log("GetUesr got data");
                    },
                    err => {
                        console.log("BindFilters Failed");
                        this.showLoader = false;
                    },
                    () => {
                        debugger
                        this._httpService.ajaxPost("Common/GetParameter", { 'ParameterTypeId': this.constant.enumParamterTypeName["StatusID"] }).subscribe(
                            data => {
                                this.statusItems = JSON.parse(JSON.stringify(data["Parameter"]));
                                this.drpAllstatusItems = JSON.parse(JSON.stringify(data["Parameter"]));
                                this.drpstatusItems = JSON.parse(JSON.stringify(data["Parameter"].filter(item => item.Value == "3" || item.Value == "5" || item.Value == "6" || item.Value == "7")));
                            },
                            err => {
                                console.log("BindStatus Failed");
                                this.showLoader = false;
                                this.GetAttendance();
                                this.geolocateUser();
                            },
                            () => {
                                this.GetAttendance();
                                this.geolocateUser();
                            }
                        );

                    }
                );
            }
        );
    }

    //-------------------- Get Geo Location of User Start-----------------------------------------
    getformattedAddress(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
            this.geoLocationModel.Address = results[0].formatted_address;
        }
        else {
            this.geoLocationModel.Address = "Unable to retrieve your address";
        }
    }
    geolocationSuccess(position) {
        var userLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            "location": userLatLng
        }, this.getformattedAddress.bind(this));
        this.geoLocationModel.Latitude = position.coords.latitude;
        this.geoLocationModel.Longitude = position.coords.longitude;
        this.showLoader = false;
    }

    geolocationError(positionError) {
        this.geoError = positionError.message;
        this.geoLocationModel = { 'IP': null, 'Latitude': null, 'Longitude': null };
        this.showLoader = false;
    }

    geolocateUser() {
        this.showLoader = true;
        this._httpService.ajaxGetIP().subscribe(
            data => {
                this.geoLocationModel.IP = data["ip"];
            },
            err => {
                this.geoLocationModel.IP = "Not Found.";
                this.showLoader = false;
                this.callGeoLocation();
            },
            () => {
                this.callGeoLocation();
                this.showLoader = false;
            }
        );
    }

    callGeoLocation() {
        if (navigator.geolocation) {
            var positionOptions = {
                enableHighAccuracy: true,
                timeout: 5000 // 3 seconds
            };
            this.showLoader = true;
            navigator.geolocation.getCurrentPosition(this.geolocationSuccess.bind(this), this.geolocationError.bind(this), positionOptions);
        }
        else {
            this.geoError = "Your browser doesn't support the Geolocation API";
            this.geoLocationModel = { 'IP': null, 'Latitude': null, 'Longitude': null };
        }
    }
    //---------------------Get Geo Location of User End-----------------------------------------

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/AttendanceMarking/attendanceMarking.component.ts
 **/